'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var classNames = require('classnames/bind');
var Alert_module = require('./Alert.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Alert_module["default"]);
var Alert = function (_a) {
    var _b = _a.border, border = _b === void 0 ? 'square' : _b, className = _a.className, children = _a.children, icon = _a.icon, margin = _a.margin, _c = _a.variant, variant = _c === void 0 ? 'warning' : _c, rest = _tslib.__rest(_a, ["border", "className", "children", "icon", "margin", "variant"]);
    return (jsxRuntime.jsxs("div", _tslib.__assign({ role: "alert", className: cx('main', "border-".concat(border), margin ? "margin-".concat(margin) : undefined, variant, className) }, rest, { children: [icon && jsxRuntime.jsx("span", { children: icon }), jsxRuntime.jsx("span", { children: children })] })));
};

exports["default"] = Alert;
//# sourceMappingURL=Alert.js.map
